module.exports = __webpack_public_path__ + "img/diamond_level1.27ef0b1d.png";